import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import { FunctionComponent } from 'react';
import styles from './DepositPendingIcon.module.scss';

interface DepositPendingIconProps {
    show?: boolean;
}

export const DepositPendingIcon: FunctionComponent<DepositPendingIconProps> = props => {
    const icon = (
        <div className={props.show ? styles.container : `${styles.container} ${styles.hidden}`}>
            <FontAwesomeIcon
                icon={faTriangleExclamation}
                fontSize={19}
            />
        </div>
    );

    if (!props.show) return icon;

    return (
        <Tooltip
            content="Deposit Pending"
            className={styles.tooltip}
        >
            {icon}
        </Tooltip>
    );
};

export default DepositPendingIcon;
